import { useEffect, useState } from "react";
import { Image, SemanticFLOATS, SemanticSIZES } from "semantic-ui-react";

interface Props {
  size?: SemanticSIZES;
  floated?: SemanticFLOATS;
  rounded?: boolean;
  onClick?: () => void;
  centered?: boolean;
  style?: any;
  file: File;
}

function TempLocalImage({ size, floated, rounded, onClick, centered, style, file }: Props) {
  const [imageUrl, setImageUrl] = useState<string>();

  useEffect(() => {
    const url = URL.createObjectURL(file);
    setImageUrl(url);

    // Cleanup the object URL when component unmounts or file changes
    return () => URL.revokeObjectURL(url);
  }, [file]);

  return (
    <Image
      src={imageUrl}
      size={size}
      floated={floated}
      rounded={rounded}
      onClick={onClick}
      centered={centered}
      style={style}
    ></Image>
  );
}

export default TempLocalImage;
